import { apiGet } from './client';

export interface Permission {
  module: string;
  action: string;
  resource?: string;
}

export function getCurrentPermissions() {
  return apiGet<Permission[]>('/auth/me/permissions');
}
